import { Form as BootstrapForm } from "react-bootstrap";
import { FormProvider } from "react-hook-form";

/**
 * Component has been deprecated and should not be used anymore.
 * @deprecated Use components from shared/ui instead
 */
export function Form({ form, onSubmit, children = null, ...props }) {
  return (
    <FormProvider {...form}>
      <BootstrapForm onSubmit={form.handleSubmit(onSubmit)} {...props}>
        {children}
      </BootstrapForm>
    </FormProvider>
  );
}
